<script>
import Title from '@components/section-title'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import Card from '@components/card-div'
import Vue from 'vue'

export default {
  components: { Title, Card },
  data() {
    return {
      busModal: new Vue(),
      lista: [],
    }
  },
  created() {
    GlobalBus.$on(MODAL.SHOW_VIDEOS, this.open)
    this.busModal.$on('close', this.close)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.SHOW_VIDEOS, this.open)
    this.busModal.$off('close', this.close)
  },
  methods: {
    close() {
      Object.values(this.$refs).forEach((ref) => {
        const item = ref[0] || ref || {}
        if (item.pause) {
          item.pause()
        }
      })
    },
    open(opts) {
      if (opts) {
        this.lista = opts.list
      }

      this.busModal.$emit('dialog', true)
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="80vw">
    <Title title="Vídeos" />
    <Card
      v-for="(item, index) in lista"
      :key="item.title"
      secondary
      class="mb-10"
    >
      <p v-if="item.title" class="subtitle"> {{ item.title }} </p>
      <p v-if="item.description" class="text-sm"> {{ item.description }} </p>
      <div class="d-flex justify-content-center" style="min-height: 50vh">
        <video
          :ref="`video-` + index"
          :src="item.url"
          style="max-width: 80%; margin: auto;"
          controls
          controlsList="nodownload"
          class="elevation-3"
        ></video>
      </div>
    </Card>
  </BaseModal>
</template>
